import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Input from "../../Builder/nodes/Logic/Inputs/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

export default function ProjectSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [label, setSearch] = useState(searchParams.get("label") || "");
  const [status, setStatus] = useState(
    searchParams.get("status")?.split(",") ?? []
  );
  const [order, setSortBy] = useState(searchParams.get("order") || "created");
  const [running, setRunning] = useState(searchParams.get("running") || "all");
  const [direction, setSortAscDesc] = useState(
    searchParams.get("direction") || "desc"
  );
  const limit = Number(searchParams.get("limit")) || 10;

  const labelStyle = {
    fontSize: 12,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    overflow: "hidden",
    marginBottom: -5,
    marginLeft: 5,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchParams({
      ...(label ? { label } : {}),
      ...(status.length > 0 ? { status: status.join(",") } : {}),
      ...(order ? { order } : {}),
      ...(running ? { running } : {}),
      ...(direction ? { direction } : {}),
      ...(limit ? { limit } : {}),
    });
  };

  return (
    <form
      className="my-4 input-group input-group-sm gap-1"
      onSubmit={handleSubmit}
    >
      <div className="flex-grow-1 ">
        <label className="text-primary" style={labelStyle}>
          Name
        </label>
        <input
          style={{ height: 40 }}
          placeholder="Search for project name"
          className="form-control"
          value={label}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
      <div style={{ minWidth: 200 }}>
        <Input
          label="Status"
          isMulti
          value={status}
          onChange={(options) => {
            setStatus(options);
          }}
          options={[
            { value: "production", label: "Production" },
            { value: "draft", label: "Draft" },
            { value: "archived", label: "Archived" },
          ]}
        />
      </div>
      <div style={{ minWidth: 100 }}>
        <Input
          label="Active now"
          inputType="select"
          value={[running]}
          onChange={(options) => {
            setRunning(options[0]);
          }}
          options={[
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
            { value: "all", label: "All" },
          ]}
        />
      </div>
      <div style={{ minWidth: 150 }}>
        <Input
          label="Order by"
          inputType="select"
          value={[order]}
          onChange={(options) => {
            setSortBy(options[0]);
          }}
          options={[
            { value: "created", label: "Created at" },
            { value: "label", label: "Label" },
            { value: "running", label: "Last run" },
          ]}
        />
      </div>
      <div style={{ minWidth: 150 }}>
        <Input
          label="Order"
          inputType="select"
          value={[direction]}
          onChange={(options) => {
            setSortAscDesc(options[0]);
          }}
          options={[
            { value: "asc", label: "Ascending" },
            { value: "desc", label: "Descending" },
          ]}
        />
      </div>
      <div>
        <label className="text-primary" style={labelStyle}>
          {" "}
        </label>
        <button
          type="submit"
          className="form-control btn btn-colored"
          style={{ height: 40 }}
        >
          <FontAwesomeIcon icon={faMagnifyingGlass} className="me-2" />
          Search
        </button>
      </div>
    </form>
  );
}
